module.exports = __webpack_public_path__ + "static/media/yewu-cj4.9e119d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-cj4.png
// module id = 604
// module chunks = 0